export default __webpack_public_path__ + "b2b58eaf38551f5410b312c6fd5096cf.png";